module.exports = __webpack_public_path__ + "img/midnight.753e5561.svg";